import { Pipe, PipeTransform } from '@angular/core';
import { MetadataService } from '../../../../../services/metadata.service';
import { TableType } from '../../../../../models/shipment';
import { Observable } from 'rxjs';
import { MetadataDataType } from '../../../../../models/metadata';

@Pipe({
  name: 'columnTypeByKey',
  standalone: true
})
export class ColumnTypeByKeyPipe implements PipeTransform {
  constructor(private metadataService: MetadataService) {}

  transform(key: string, type: TableType): Observable<MetadataDataType> {
    return this.metadataService.getColumnDataTypeBy(key, type);
  }
}
